"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UIPage = require("./../UIPage.js"),
    $ = "undefined" != typeof window ? window.jQuery : "undefined" != typeof global ? global.jQuery : null,
    template = require("./ProspectCalls.html"),
    api = require("./../../../network/api.js"),
    regionalLayout = require("./../../layouts/RegionalLayout.js"),
    PhoneCallScore = require("../../components/PhoneCall/PhoneCallScore.js"),
    PropertySelector = require("../../components/propertyselector/propertyselector.js"),
    utilities = require("./../../../utilities.js"),
    InboundCalls = require("./../../tables/InboundCalls"),
    SelectedPropertiesKey = "ReportFilters_SelectedProperties";
var ProspectCalls = function (_UIPage) {
  _inherits(ProspectCalls, _UIPage);

  function ProspectCalls() {
    var _this;

    _classCallCheck(this, ProspectCalls);

    (_this = _possibleConstructorReturn(this, (ProspectCalls.__proto__ || Object.getPrototypeOf(ProspectCalls)).call(this, template, { layout: regionalLayout, title: "Inbound Calls" })), _this), _this.phoneCallsdata, _this.propertySelectorComponent = null, _this.inboundCallsTable = null, _this.selectedProperties = null;return _this;
  }

  _createClass(ProspectCalls, [{
    key: "onComponentReady",
    value: function onComponentReady(e) {
      var _this2 = this;

      document.querySelector("omnibar-shell").pageId = "regionalinboundcalls", document.querySelector("omnibar-page-header").pageTitle = "Inbound Calls", window.Omnibar.GetPropertyLevelHelpLink(window.location), this.getPhonecall(), this.getTaggedUsers(), this.bindEvents(), $(this.refs.txtSearch).on("keyup", function () {
        $(_this2.refs.tblPhoneCalls).dataTable().fnFilter($(_this2.refs.txtSearch).val());
      }), $(this.refs.applyFilter).on("click", function () {
        _this2.getPhonecall(_this2.propertySelectorComponent.selectedProperties);
      });
    }
  }, {
    key: "bindEvents",
    value: function bindEvents() {
      var _this3 = this;

      this.clearObjectUrl(), $("#modal .box-close").on("click", function () {
        $(_this3.refs.screenOverLay).hide(), $(_this3.refs.modal).hide(), void 0 !== $($("#modal").find("iframe")[0]).contents().find("audio")[0] && ($($("#modal").find("iframe")[0]).contents().find("audio")[0].pause(), _this3.clearObjectUrl()), _this3.getPhonecall(_this3.propertySelectorComponent.selectedProperties), _this3.updateTable();
      }), this.showPropertrySelector();
    }
  }, {
    key: "showPropertrySelector",
    value: function showPropertrySelector() {
      this.propertySelectorComponent = new PropertySelector(), this.propertySelectorComponent.attach(this.refs.propertySelector), this.propertySelectorComponent.renderAsync();
    }
  }, {
    key: "filterGrid",
    value: function filterGrid(e) {
      $("#tblPhoneCalls_filter").find("input[type=search]").val(e);
    }
  }, {
    key: "getPhonecall",
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        var t, l;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                t = null;

                if (!(null == e)) {
                  _context.next = 7;
                  break;
                }

                _context.next = 4;
                return this.getSelectedProperties();

              case 4:
                _context.t0 = _context.sent;
                _context.next = 8;
                break;

              case 7:
                _context.t0 = e;

              case 8:
                t = _context.t0;
                l = { DateRange: $(this.refs.ddlTimeRange).val(), Properties: t, StartRow: 1, RowCount: 10, OrderBy: "Calldate", OrderDesc: !0 };
                this.inboundCallsTable = InboundCalls($(this.refs.tabelContainer), l), this.updateTable();
              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getPhonecall() {
        return _ref.apply(this, arguments);
      }

      return getPhonecall;
    }()
  }, {
    key: "getTaggedUsers",
    value: function getTaggedUsers() {
      var _this4 = this;

      api.v1.users.taggedUsers.get($(this.refs.ddlTimeRange).val(), function (e, t) {
        null === e && ($(_this4.refs.ddlTaged).children("option:not(:first)").remove(), $.each(t, function (e, t) {
          var l = "<option value=" + t.TaggedUserId + ">" + t.FullName + "</option>";$(_this4.refs.ddlTaged).append(l);
        }));
      });
    }
  }, {
    key: "updateTable",
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        var t, l, r, o;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.getSelectedProperties(e);

              case 2:
                t = _context2.sent;
                l = $(this.refs.ddlTimeRange).val();
                r = $(this.refs.ddlTaged).val();
                o = $(this.refs.txtSearch).val();
                this.inboundCallsTable.update(parseInt(l), parseInt(r), o, t);
              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function updateTable() {
        return _ref2.apply(this, arguments);
      }

      return updateTable;
    }()
  }, {
    key: "getSelectedProperties",
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.t0 = e;

                if (_context3.t0) {
                  _context3.next = 5;
                  break;
                }

                _context3.next = 4;
                return utilities.storage.indexeddb.getAsync(SelectedPropertiesKey);

              case 4:
                _context3.t0 = e = _context3.sent;

              case 5:
                _context3.t1 = _context3.t0;

                if (_context3.t1) {
                  _context3.next = 8;
                  break;
                }

                e = [];

              case 8:
                return _context3.abrupt("return", e);

              case 9:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getSelectedProperties() {
        return _ref3.apply(this, arguments);
      }

      return getSelectedProperties;
    }()
  }, {
    key: "clearObjectUrl",
    value: function clearObjectUrl() {
      localStorage.inboundCallsUrl && (URL.revokeObjectURL(localStorage.inboundCallsUrl), localStorage.inboundCallsUrl = null);
    }
  }]);

  return ProspectCalls;
}(UIPage);

module.exports = ProspectCalls;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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